import { render } from "./agentPromotion.vue?vue&type=template&id=6ea7c08b&scoped=true"
import script from "./agentPromotion.vue?vue&type=script&lang=js"
export * from "./agentPromotion.vue?vue&type=script&lang=js"

import "./agentPromotion.vue?vue&type=style&index=0&id=6ea7c08b&scoped=true&lang=css"
import "./agentPromotion.vue?vue&type=style&index=1&id=6ea7c08b&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea7c08b"]])

export default __exports__